<template>

    <v-button class="p-0" size="sm" btn-style="white" :style="styles">
        <i class="fs-16" :class="icon"></i>
    </v-button>

</template>

<script>

export default {

    props: {
        icon: {
            type: String,
            default: 'fas fa-plus',
        },
        size: {
            type: Number,
            default: 40,
        },
    },

    computed: {

        styles() {
            return {
                'width': this.size + 'px',
                'height': this.size + 'px',
            };
        }

    },

}

</script>